import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=26bd4516&scoped=true&"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=26bd4516&prod&lang=css&"
import style1 from "./OrganizationDetails.vue?vue&type=style&index=1&id=26bd4516&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd4516",
  null
  
)

export default component.exports